import { Component, inject } from '@angular/core';
import { TaasButtonComponent, ToastService } from 'utimaco-common-ui-angular';
import { TaasUserService } from '../../core/services/taas-user-service.service';

@Component({
  selector: 'app-taas-ts-home',
  standalone: true,
  imports: [TaasButtonComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class TaasTsHomeComponent {
  public taasUserService: TaasUserService = inject(TaasUserService);
  private toastService: ToastService = inject(ToastService);

  public buttonLabel: string = $localize`:exampleButtonLabel:Trigger Toast Message`;

  public showToastMessage(){
    this.toastService.info($localize`:exampleToastTitle:Example Toast Message`, $localize`:exampleToastMessage:This is an Info Toast Message example`);
  }
}
